import { Navigate, useLocation } from "react-router-dom";

export default function SectionJobsPage() {
  const location = useLocation();
  return <Navigate to={`${location.pathname}/list`} replace />;
}
